<template>
  <v-menu :close-on-content-click="!multiple">
    <template v-slot:activator="{ on }">
      <v-btn rounded color="blue" outlined v-on="on">
        <v-icon class="me-2">mdi-folder-outline</v-icon>
        {{ $t('common.group_one') }}
      </v-btn>
    </template>
    <v-list class="ma-0 pa-0">
      <v-subheader
        class="overline blue-grey--text text--darken-1 ma-0 py-2 px-4"
        >{{ title.toUpperCase() }}</v-subheader
      >
      <v-divider />
      <v-list-item-group
        v-if="options.length"
        v-model="selectedGroups"
        class="ma-0 pa-0 py-2"
        style="max-height: 250px; overflow-y: scroll;"
        :multiple="multiple"
      >
        <v-list-item
          v-for="group in options"
          class="ma-0 py-0 px-4"
          :key="group.id"
          :value="group"
          @click="handleClick(group)"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action class="ma-0 pa-0 me-4" v-if="multiple">
              <v-checkbox
                color="primary"
                class="ma-0 pa-0"
                :ripple="false"
                :input-value="active"
              />
            </v-list-item-action>
            <v-list-item-content class="ma-0 pa-0">
              <v-list-item-title
                class="ma-0 pa-0 font-size-13 blue-grey--text text--darken-3 font-weight-500"
                >{{ group.name }}</v-list-item-title
              >
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
      <div
        v-else
        style="height: 250px;"
        class="d-flex flex-column justify-center align-center"
      >
        <v-icon color="blue-grey lighten-1">
          mdi-ghost-outline
        </v-icon>
        <p class="mt-2 ma-0 pa-0 overline">
          {{ $t('organization_structure.groups_empty_state') }}
        </p>
      </div>
      <v-divider />
      <v-list-item class="ma-0 pa-0 px-4" @click="$emit('createGroup')">
        <v-icon color="blue-grey darken-1" size="20" class="me-4"
          >mdi-plus-circle-outline</v-icon
        ><v-list-item-title
          class="ma-0 pa-0 font-size-13 blue-grey--text text--darken-3 font-weight-500"
          >{{ $t('common.create_new') }}</v-list-item-title
        >
      </v-list-item>
      <v-list-item class="ma-0 pa-0 px-4 pb-2" @click="$emit('manageGroups')">
        <v-icon color="blue-grey darken-1" size="20" class="me-4"
          >mdi-cog-outline </v-icon
        ><v-list-item-title
          class="ma-0 pa-0 font-size-13 blue-grey--text text--darken-3 font-weight-500"
          >{{
            $t('organization_structure.manage_tags_groups')
          }}</v-list-item-title
        >
      </v-list-item>
      <v-divider v-if="multiple" />
      <div class="d-flex justify-center py-2" v-if="multiple">
        <v-btn text color="blue" @click="$emit('apply', selectedGroups)">{{
          $t('common.apply')
        }}</v-btn>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'Group',

  props: {
    groups: { required: true, type: Array },
    multiple: Boolean,
    title: { required: true, type: String },
  },

  data() {
    return {
      selectedGroups: [],
    }
  },

  computed: {
    options() {
      return this.groups.toReversed()
    },
  },

  methods: {
    handleClick(group) {
      this.$emit('apply', group)
    },
  },
}
</script>
